import { render, staticRenderFns } from "./app-manage.vue?vue&type=template&id=5c4fe1a4&scoped=true&"
import script from "./app-manage.js?vue&type=script&lang=js&"
export * from "./app-manage.js?vue&type=script&lang=js&"
import style0 from "./app-manage.scss?vue&type=style&index=0&id=5c4fe1a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4fe1a4",
  null
  
)

component.options.__file = "app-manage.vue"
export default component.exports